export default "__VITE_ASSET__BMrx_Pa4__"